import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { generateColorVariants } from "../../utils/functions";
import { SwitchArea, SwitchLabel } from "./styles";
import { forwardRef, useMemo } from "react";
import { Spinner } from "../Spinner";
import { useTheme } from "styled-components";
export var Switch = forwardRef(function Switch(_a, ref) {
    var label = _a.label, _b = _a.labelPosition, labelPosition = _b === void 0 ? "right" : _b, customColor = _a.customColor, isLoading = _a.isLoading, register = _a.register, props = __rest(_a, ["label", "labelPosition", "customColor", "isLoading", "register"]);
    var theme = useTheme();
    var colorVariants = customColor
        ? useMemo(function () { return generateColorVariants(customColor); }, [customColor])
        : undefined;
    return (_jsxs(SwitchLabel, { "$labelPosition": labelPosition, children: [_jsx("input", __assign({ ref: ref, type: "checkbox" }, props, { disabled: isLoading || props.disabled }, register)), label && _jsx("span", { children: label }), _jsx(SwitchArea, { "$colorVariants": colorVariants, "$isLoading": isLoading, children: _jsx(Spinner, { size: 10, color: theme.colors.neutral.lighter, style: {
                        position: "absolute",
                        left: 14,
                        top: 4,
                        transition: "all 0.3s cubic-bezier(0.65, 0, 0.35, 1)",
                        zIndex: 1,
                        opacity: isLoading ? 1 : 0,
                    } }) })] }));
});
//# sourceMappingURL=index.js.map